import * as types from "./actionsTypes";

export function setActiveGroups(groups) {
  return {
    type: types.SET_ACTIVE_GROUPS,
    data: groups,
  };
}
